import moment from 'moment'

export const DEFUALT_PAGE = 0;
export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_REQUEST_TYPE = 'received'

export const isExpired = date => moment.utc(
    moment((date.seconds || date._seconds) * 1000)
).isBefore(moment().subtract(1, 'days'))


export const REQUESTS_TABLE_COLUMNS  = [
    {
        title: 'My Campaign',
        key: 'myCampaign',
        slot: {
            name: 'MyCampaign'
        }
    },
    {
        title: 'Partner Campaign',
        key: 'partnerCampaign',
        slot: {
            name: 'PartnerCampaign'
        }
    },
    {
        title: 'SUGGESTED SPOTS (MY < PARTNER’S)',
        key: 'suggestedSpots',
        slot: {
            name: 'SuggestedSpots'
        }
    },
    {
        title: 'Status',
        key: 'status',
        slot: {
            name: 'Status'
        }
    },
    {
        title: 'request date',
        key: 'requestDate',
        slot: {
            name: 'Date'
        },
        sortable: true
    },
    {
        title: '',
        key: 'chat',
        slot: {
            name: 'Chat'
        }
    },
    {
        title: '',
        key: 'action',
        slot: {
            name: 'Action'
        }
    },
];

export const SCHEDULED_UPDATES_TABLE_COLUMNS = [
    {
        title: 'My Campaign',
        key: 'myCampaign',
        slot: {
            name: 'UpdateCampaign'
        }
    },
    {
        title: 'Update Date',
        key: 'updateDate',
        slot: {
            name: 'Date'
        }
    },
    {
        title: 'Status',
        key: 'status',
        slot: {
            name: 'UpdatesStatus'
        }
    },
    {
        title: 'My Update Spots',
        key: 'updateSpots',
        slot: {
            name: 'UpdateSpots'
        }
    },
    {
        title: '',
        key: 'cpInfo',
        slot: {
            name: 'CpInfo'
        }
    },
];


export const UNSCHEDULED_UPDATES_TABLES_COLUMNS = [
    {
        title: '',
        key: 'myCampaign',
        slot: {
            name: 'UpdateCampaign'
        }
    },
    {
        title: '',
        key: 'notScheduled',
        slot: {
            name: 'NotScheduledUpdates'
        }
    },
    {
        title: '',
        key: 'scheduleNow',
        slot: {
            name: 'ScheduleUpdate'
        }
    },
]


export const INVOICE_TABLE_COLUMNS = [
    {
        title: 'Date',
        key: 'invoiceDates',
        slot: {
            name: 'InvoiceDates'
        }
    },
    {
        title: 'Description',
        key: 'invoiceDescription',
        slot: {
            name: 'Description'
        }
    },
    {
        title: 'Amount',
        key: 'invoiceAmount',
        slot: {
            name: 'Amount'
        }
    },
    {
        title: 'Status',
        key: 'invoiceStatus',
        slot: {
            name: 'InvoiceStatus'
        }
    },
    {
        title: 'Invoice',
        key: 'invoiceFile',
        slot: {
            name: 'InvoiceFile'
        }
    },
]

export const EMPTY_STATES = {
    receivedRequest: {
        icon: 'empty-state-no-request',
        emptyStateTitle: '',
        emptyStateDesc: "You don’t have received requests yet.",
        emptyStateButtonText: '',
        routeTo: ''
    },
    sentRequest: {
        icon: 'empty-state-no-request',
        emptyStateTitle: '',
        emptyStateDesc: "Don’t wait for it. Request CrossProms!",
        emptyStateButtonText: 'Go send some requests',
        routeTo: '/'
    },
    noCampaign: {
        icon: 'empty-state-no-request',
        emptyStateTitle: "You don't have a campaign yet.",
        emptyStateDesc: 'Add campaign and start sending CrossProm Requests.',
        emptyStateButtonText: '+ Add Campaign',
        routeTo: "/wizard?from=/dashboard/requests"
    },
    scheduledUpdates: {
        icon: 'empty-state-no-updates',
        emptyStateTitle: '',
        emptyStateDesc: 'You don’t have any scheduled updates yet.',
        emptyStateButtonText: 'Schedule Now',
        routeTo: '/dashboard/campaigns/publish'
    },
    notScheduledUpdates: {
        icon: 'empty-state-no-updates',
        emptyStateTitle: '',
        emptyStateDesc: 'You don’t have any unscheduled updates.',
        emptyStateButtonText: '',
        routeTo: ''
    }
}

export const statuses = {
    requests: ['confirmed','declined','cancelled','pending', 'expired'],
    updates: ['pending', 'posted']
}

export const daysPassed = (date) => {
    if(date.seconds) {
        date = new Date(date.seconds * 1000)
    }
    const now = moment();
    const startDay = moment(date)
    const duration = moment.duration(now.diff(startDay))
    return Math.floor(duration.asDays())
}